import { render, staticRenderFns } from "./BaseFooterCancelTheOrder.vue?vue&type=template&id=4dba9477&scoped=true&"
import script from "./BaseFooterCancelTheOrder.vue?vue&type=script&lang=js&"
export * from "./BaseFooterCancelTheOrder.vue?vue&type=script&lang=js&"
import style0 from "./BaseFooterCancelTheOrder.vue?vue&type=style&index=0&id=4dba9477&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dba9477",
  null
  
)

export default component.exports